import { Node } from 'prosemirror-model';

export enum EventsEnum {
  ImageGeneration = 'IMAGE_GENERATION',
  KnowledgeDocCreation = 'KNOWLEDGE_DOC_CREATION',
}

export interface Events {
  [EventsEnum.ImageGeneration]: {
    node: Node;
    updateAttrs: (attrs: Object) => void;
  };
  [EventsEnum.KnowledgeDocCreation]: {};
  // Index signature for unknown events
  [key: string]: unknown;
}

export type ImageGenerativeTaskEvent = Events[EventsEnum.ImageGeneration];
